import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type WordmarkProps = {
  className?: string;
  to?: string;
  size?: "sm" | "md" | "lg";
};

const SIZE_CLASS = {
  sm: "h-7",
  md: "h-8",
  lg: "h-10",
} as const;

export const Wordmark = ({ className, to = "/", size = "md" }: WordmarkProps) => (
  <Link to={to} className={cn("inline-flex items-center", className)}>
    <img
      src="/brand/logo-full.svg"
      alt="Talki"
      className={cn("w-auto", SIZE_CLASS[size])}
    />
  </Link>
);

export const WordmarkMark = ({ className }: { className?: string }) => (
  <img
    src="/brand/logo-icon.svg"
    alt="Talki"
    className={cn("h-8 w-8", className)}
  />
);
